import React from 'react';
import { Heart, Trophy, Zap, Check, Clock, AlertCircle, Image, Gift } from 'lucide-react';
export const Dashboard = () => {
  return <section className="space-y-4" data-id="element-6553">
      <div className="flex items-center justify-between" data-id="element-6554">
        <h2 className="text-lg font-bold" data-id="element-6555">Your Progress</h2>
        <button className="text-sm text-pink-400" data-id="element-6556">View Stats</button>
      </div>
      <div className="bg-gray-900 rounded-xl border-0 sm:border sm:border-gray-800/30 p-4" data-id="element-6557">
        <div className="flex items-center gap-4" data-id="element-6558">
          <div className="relative" data-id="element-6559">
            <div className="w-16 h-16 rounded-full flex items-center justify-center bg-gradient-to-br from-pink-600 to-purple-600" data-id="element-6560">
              <span className="text-xl font-bold" data-id="element-6561">5</span>
            </div>
            <svg className="absolute inset-0 w-16 h-16 -rotate-90" data-id="element-6562">
              <circle cx="32" cy="32" r="28" fill="none" stroke="#4B5563" strokeWidth="4" data-id="element-6563" />
              <circle cx="32" cy="32" r="28" fill="none" stroke="url(#gradient)" strokeWidth="4" strokeDasharray="176" strokeDashoffset="70" data-id="element-6564" />
              <defs data-id="element-6565">
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-6566">
                  <stop offset="0%" stopColor="#EC4899" data-id="element-6567" />
                  <stop offset="100%" stopColor="#8B5CF6" data-id="element-6568" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div data-id="element-6569">
            <h3 className="font-bold" data-id="element-6570">Intimacy Level 5</h3>
            <p className="text-sm text-gray-400" data-id="element-6571">Flame Stage (250/500 XP)</p>
            <div className="mt-1 flex items-center gap-2" data-id="element-6572">
              <Heart size={14} className="text-pink-500" data-id="element-6573" />
              <div className="w-24 h-2 bg-gray-700 rounded-full overflow-hidden" data-id="element-6574">
                <div className="h-full bg-gradient-to-r from-pink-500 to-pink-400 w-1/2 rounded-full" data-id="element-6575"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-900 rounded-xl border-0 sm:border sm:border-gray-800/30" data-id="element-6576">
        <div className="p-3 border-b-0 sm:border-b sm:border-gray-800/30" data-id="element-6577">
          <h3 className="font-medium" data-id="element-6578">Daily Missions</h3>
        </div>
        <div className="divide-y divide-gray-800/30" data-id="element-6579">
          <div className="p-3 flex items-center justify-between" data-id="element-6580">
            <div className="flex items-center gap-3" data-id="element-6581">
              <div className="w-8 h-8 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-6582">
                <Heart size={14} data-id="element-6583" />
              </div>
              <div data-id="element-6584">
                <p className="text-sm font-medium" data-id="element-6585">React to 3 AI posts</p>
                <p className="text-xs text-gray-400" data-id="element-6586">2/3 completed</p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-6587">
              <span className="text-xs text-pink-400" data-id="element-6588">+5 💗</span>
              <button className="px-2 py-1 bg-gray-800 rounded-full text-xs" data-id="element-6589">
                Go
              </button>
            </div>
          </div>
          <div className="p-3 flex items-center justify-between bg-gradient-to-r from-pink-900/20 to-transparent" data-id="element-6590">
            <div className="flex items-center gap-3" data-id="element-6591">
              <div className="w-8 h-8 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400 animate-pulse" data-id="element-6592">
                <Clock size={14} data-id="element-6593" />
              </div>
              <div data-id="element-6594">
                <div className="flex items-center gap-2" data-id="element-6595">
                  <p className="text-sm font-medium" data-id="element-6596">Say hi to your Angel</p>
                  <div className="px-1.5 py-0.5 bg-red-500/20 rounded text-xs text-red-400 flex items-center gap-1" data-id="element-6597">
                    <Clock size={10} data-id="element-6598" />
                    <span data-id="element-6599">25:32</span>
                  </div>
                </div>
                <div className="flex items-center gap-1 mt-0.5" data-id="element-6600">
                  <AlertCircle size={10} className="text-amber-400" data-id="element-6601" />
                  <p className="text-xs text-amber-400" data-id="element-6602">
                    Expires in 4:18 (must start within 10 min)
                  </p>
                </div>
                <div className="flex items-center gap-2 mt-1" data-id="element-6603">
                  <div className="flex items-center gap-1" data-id="element-6604">
                    <Image size={10} className="text-purple-400" data-id="element-6605" />
                    <span className="text-xs text-gray-400" data-id="element-6606">Free unlock</span>
                  </div>
                  <span className="text-xs text-gray-400" data-id="element-6607">or</span>
                  <div className="flex items-center gap-1" data-id="element-6608">
                    <Gift size={10} className="text-pink-400" data-id="element-6609" />
                    <span className="text-xs text-gray-400" data-id="element-6610">10 tokens</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-6611">
              <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-xs text-white" data-id="element-6612">
                Start Now
              </button>
            </div>
          </div>
          <div className="p-3 flex items-center justify-between" data-id="element-6613">
            <div className="flex items-center gap-3" data-id="element-6614">
              <div className="w-8 h-8 flex items-center justify-center bg-green-500/20 rounded-full text-green-400" data-id="element-6615">
                <Check size={14} data-id="element-6616" />
              </div>
              <div data-id="element-6617">
                <p className="text-sm font-medium" data-id="element-6618">Send a voice message</p>
                <p className="text-xs text-gray-400" data-id="element-6619">Completed</p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-6620">
              <span className="text-xs text-pink-400" data-id="element-6621">+10 💗</span>
              <button className="px-2 py-1 bg-green-500/20 rounded-full text-xs text-green-400" data-id="element-6622">
                Claimed
              </button>
            </div>
          </div>
          <div className="p-3 flex items-center justify-between" data-id="element-6623">
            <div className="flex items-center gap-3" data-id="element-6624">
              <div className="w-8 h-8 flex items-center justify-center bg-purple-500/20 rounded-full text-purple-400" data-id="element-6625">
                <Zap size={14} data-id="element-6626" />
              </div>
              <div data-id="element-6627">
                <p className="text-sm font-medium" data-id="element-6628">Use the Buzz feature</p>
                <p className="text-xs text-gray-400" data-id="element-6629">0/3 completed</p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-6630">
              <span className="text-xs text-pink-400" data-id="element-6631">+15 💗</span>
              <button className="px-2 py-1 bg-gray-800 rounded-full text-xs" data-id="element-6632">
                Go
              </button>
            </div>
          </div>
        </div>
        <div className="p-3 border-t-0 sm:border-t sm:border-gray-800 flex items-center justify-between" data-id="element-6633">
          <div className="flex items-center gap-1" data-id="element-6634">
            <Clock size={14} className="text-gray-400" data-id="element-6635" />
            <span className="text-xs text-gray-400" data-id="element-6636">Refreshes in 8h 24m</span>
          </div>
          <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-xs font-medium" data-id="element-6637">
            Claim All Rewards
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4" data-id="element-6638">
        <div className="bg-gray-900 rounded-xl border border-gray-800 p-3" data-id="element-6639">
          <div className="flex items-center gap-2 mb-2" data-id="element-6640">
            <Trophy size={16} className="text-yellow-400" data-id="element-6641" />
            <h3 className="font-medium" data-id="element-6642">Achievements</h3>
          </div>
          <div className="grid grid-cols-4 gap-2" data-id="element-6643">
            <div className="aspect-square flex items-center justify-center bg-yellow-500/20 rounded-lg border border-yellow-500/30 text-yellow-400" data-id="element-6644">
              👑
            </div>
            <div className="aspect-square flex items-center justify-center bg-pink-500/20 rounded-lg border border-pink-500/30 text-pink-400" data-id="element-6645">
              💋
            </div>
            <div className="aspect-square flex items-center justify-center bg-purple-500/20 rounded-lg border border-purple-500/30 text-purple-400" data-id="element-6646">
              🔥
            </div>
            <div className="aspect-square flex items-center justify-center bg-gray-800 rounded-lg border border-gray-700 text-gray-500" data-id="element-6647">
              🔒
            </div>
          </div>
          <p className="text-xs text-center mt-2 text-gray-400" data-id="element-6648">
            3/12 unlocked
          </p>
        </div>
        <div className="bg-gray-900 rounded-xl border border-gray-800 p-3" data-id="element-6649">
          <div className="flex items-center gap-2 mb-2" data-id="element-6650">
            <Trophy size={16} className="text-yellow-400" data-id="element-6651" />
            <h3 className="font-medium" data-id="element-6652">Leaderboard</h3>
          </div>
          <div className="space-y-2" data-id="element-6653">
            <div className="flex items-center justify-between" data-id="element-6654">
              <div className="flex items-center gap-2" data-id="element-6655">
                <span className="text-xs font-medium text-yellow-400" data-id="element-6656">1</span>
                <span className="text-sm" data-id="element-6657">User123</span>
                <span className="text-xs px-1 bg-yellow-500/20 rounded text-yellow-400" data-id="element-6658">
                  👑
                </span>
              </div>
              <span className="text-xs" data-id="element-6659">1,240 💗</span>
            </div>
            <div className="flex items-center justify-between" data-id="element-6660">
              <div className="flex items-center gap-2" data-id="element-6661">
                <span className="text-xs font-medium text-gray-400" data-id="element-6662">2</span>
                <span className="text-sm" data-id="element-6663">LoverBoy</span>
                <span className="text-xs px-1 bg-purple-500/20 rounded text-purple-400" data-id="element-6664">
                  💜
                </span>
              </div>
              <span className="text-xs" data-id="element-6665">980 💗</span>
            </div>
            <div className="flex items-center justify-between" data-id="element-6666">
              <div className="flex items-center gap-2" data-id="element-6667">
                <span className="text-xs font-medium text-amber-400" data-id="element-6668">3</span>
                <span className="text-sm" data-id="element-6669">You</span>
              </div>
              <span className="text-xs" data-id="element-6670">720 💗</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
};